import { reactive } from "vue";
import axios from "axios";

export const state = reactive({
    user: {
        informations: {
            firstname: '',
            name: '',
            birthday: '',
            birthplace: '',
        },
        contact: {
            email: '',
            tel: '',
        },
        location: {
            addressLine1: '',
            addressLine2: '',
            state: '',
            city: '',
            country: '',
            zipcode: ''
        }
    },
    formation: {
        certificate: '',
        justification: ''
    },
    files: [],
    toast: {
        show: false,
        message: ''
    },
    postSuccess: false,
    respMsg: ''
});

// const URL_API = 'http://localhost:8888/wp-json/api/v1/';
axios.interceptors.request.use((config) => {
    config.headers['X-WP-Nonce'] = wpApiSettings.nonce;
    return config;
});

export async function send() {
    const data = {
        user: state.user,
        formation: state.formation,
    }

    let formData = new FormData();

    Object.keys(data).forEach(key => {
        if (typeof state[key] !== 'object') {
            formData.append(key, state[key]);
        } else {
            formData.append(key, JSON.stringify(state[key]));
        }
    });

    state.files.forEach(file => {
        formData.append(file.name, file);
    });

    await axios({
        method: 'POST',
        url: wpApiSettings.root + 'api/v1/adhesion/non-pro',
        headers: { 'Content-Type': 'multipart/form-data' },
        data: formData
    })
        .then(res => {
            state.postSuccess = true;
            state.respMsg = res.data;
        })
        .catch(err => {
            showToast(err.response.data.message);
        })
}

function showToast(message) {
    state.toast.show = true;
    state.toast.message = message;

    setTimeout(() => state.toast.show = false, 3000);
}